module.exports = __webpack_public_path__ + "static/assets/3402e91056becf65a36927480fb65cae.png";